'use client';

import React from 'react';
import clsx from 'clsx';
import useCheckoutState from '../hooks/useCheckoutState';
import { checkoutTypes } from '../enums/checkout-types';

// Fixed colours, not theme variables: a merchant's theme must not be able to
// restyle or hide the one signal that says this page takes no real money.
export default function TestModeBanner({ placement = 'page' }) {
  const { isTestMode, isTestingPayments, checkout, checkoutType } = useCheckoutState();

  // A popup floats over the merchant's own site, where a page-wide strip lands on the
  // backdrop, detached from the checkout. In a popup it sits above the title instead.
  const isPopup = checkoutType === checkoutTypes.POPUP;

  // The owner's test payments preview runs in test mode on its own, so the banner is kept
  // for pages whose test mode reaches buyers too.
  const isPreviewOnlyTestMode = isTestingPayments && checkout?.testmode !== true;

  if (!isTestMode || isPreviewOnlyTestMode || isPopup !== (placement === 'title')) {
    return null;
  }

  return (
    <div
      role="status"
      className={clsx(
        placement === 'title' && 'mb-3 rounded-md',
        placement === 'page' && 'relative z-10',
        'bg-chocolate-600 px-4 py-[9px] text-center text-[13px] leading-[1.4] font-semibold text-white',
      )}
    >
      Test payments only
    </div>
  );
}
